import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Pipe({
  name: 'safeSvg',
  standalone: true,
})
export class SafeSvgPipe implements PipeTransform {
  constructor(protected sanitizer: DomSanitizer) {}

  public transform(value: string | null | undefined): ReturnType<DomSanitizer['bypassSecurityTrustHtml']> | string {
    if (!value || value.indexOf('<svg') < 0) {
      console.warn('SafeSvgPipe needs a svg element');
      return '';
    }

    return this.sanitizer.bypassSecurityTrustHtml(value);
  }
}
